import { ReactNode } from "react";
import { CoverageDisclaimer, CoverageActionSelector } from ".";
import { CoverageActionKey } from "../types";

type Props = {
    action: CoverageActionKey;
    onActionChange: (action: CoverageActionKey) => void;
    children?: ReactNode;
    header?: ReactNode;
};

const CoverageToolPageLayout = ({
    action,
    children,
    header,
    onActionChange,
}: Props) => {
    const shouldShowDisclaimer =
        action !== "MAIL_ORDER_PRICES" && action !== "NONE";

    return (
        <div className="flex flex-col items-center w-full mx-auto">
            <div className="w-full overflow-hidden rounded-lg shadow-md bg-white p-4">
                <div className="flex-col flex md:flex-row justify-between mb-5">
                    <h1 className="text-2xl pt-2 font-bold md:text-4xl">
                        See Coverage Now
                    </h1>
                    {header && header}
                </div>
                <div>
                    <CoverageActionSelector
                        value={action}
                        onChange={onActionChange}
                    />
                </div>

                <div className="flex flex-wrap gap-3 items-end w-full mt-4">
                    {children}
                </div>

                {shouldShowDisclaimer && <CoverageDisclaimer />}
            </div>
        </div>
    );
};

export default CoverageToolPageLayout;
